import request from '@/config/axios'
import type { UserLoginVO } from '@/config/axios/types'
export type UserVO = {
  id: number
  username: string
  email: string
  registrationCode: string
  vipExpireTime: string
  vipTag: boolean
  dailyPlayLimitMinutes: number | string | null
}

export type RegisterVO = {
  username: string
  email: string
  password: string
  registrationCode: string
}

export type ResetPasswordValidate = {
  username: string
  email: string
}

export type SignRecordVO = {
  id: number
  userId: number
  continuousDays: number
  createTime: number
}

export type SignSummaryVO = {
  year: number
  month: number
  todaySigned: boolean
  continuousDays: number
  signedDates: number[][]
  signedDays: number[]
  records: SignRecordVO[]
}

export const login = (data: UserLoginVO) => {
  return request.post({
    url: '/auth/login',
    data
  })
}

export const logout = () => {
  return request.post({
    url: '/auth/logout'
  })
}

export const validateRegistrationCode = (code: string) => {
  return request.get({
    url: '/registration-code/validate-registration-code?code='+code
  })
}

export const register = (data: RegisterVO) => {
  return request.post({
    url: '/auth/register',
    data
  })
}

export const getUser = () => {
  return request.get({
    url: '/user/get'
  })
}

export const forgotUsername = (link: string) => {
  return request.get({
    url: '/auth/forgot-username?link='+link
  })
}

export const resetPasswordValidate = (data: any) => {
  return request.post({
    url: '/auth/validate-reset-password',
    data
  })
}

export const resetPassword = (data: any) => {
  return request.post({
    url: '/auth/reset-password',
    data
  })
}

export const verifyPassword = (password: string) => {
  return request.get({
    url: '/user/verifyPassword?password=' + encodeURIComponent(password)
  })
}

export const updateUser = (data: any) => {
  return request.put({
    url: '/user/update',
    data
  })
}

export const addSign = () => {
  return request.post({
    url: '/user-sign/sign'
  })
}

export const getSignSummary = (year: number, month: number) => {
  return request.get<SignSummaryVO>({
    url: '/user-sign/summary?year='+year+'&month='+month
  })
}

export const activateVip = (code: string) => {
  return request.get({
    url: '/user/activate/vip?code=' + code
  })
}
